import getFirstParagraph from './getFirstParagraph';

//------------------------------------------------------------------------------
// CONSTANTS FOR REAL ESTATE:
//------------------------------------------------------------------------------
const scopeOfAgreementRealEstate = () => `
  <h3>SCOPE OF AGREEMENT:</h3>
  <p>
    This Agreement applies to any photograph, graphics, digital assets, or digital images
    created or taken by Photographer and delivered to the Client (collectively known as “PHOTOS”)
    for the property (“PROPERTY”). This Agreement governs the relationship between the parties
    and in no event shall any e-mail communication or other exchange, amend or otherwise modify
    the terms of this Agreement unless agreed to in writing.
  </p>
`;
//------------------------------------------------------------------------------
const rightsRealEstate = () => `
  <h3>RIGHTS:</h3>
  <p>
    All Photos and rights relating to them, including copyright and ownership rights in the
    media in which the Photos are stored, remain the sole and exclusive property of the
    Photographer. This license provides the Client with the limited right to reproduce,
    publicly display, and distribute the Photos only for promotional or advertising purposes
    directly related to the sale of the Property. Photos used for any purpose not directly
    related to the sale of the Property must be with the express permission of Photographer and
    the payment of additional fees, unless otherwise agreed to in writing.
  </p>
  <p>
    Photos may be uploaded to any MLS listing service solely for promotion of the Property during
    the pendency of this Agreement. However, regardless of any terms and conditions of the MLS, at
    no time does this Agreement provide Client with the right to transfer copyright, or any other
    exclusive rights as provided by the Copyright Act 17 U.S.C § 106. Photos may contain copyright management
    information (CMI) at the discretion of the Photographer in the form of either 1) a copyright notice ©
    and/or 2) other copyright and ownership information embedded in the metadata or elsewhere, unless
    otherwise agreed to by the Parties. Removing and/or altering such information is prohibited and
    constitutes violation of the Digital Millennium Copyright Act (DMCA) and Client will be responsible
    to the Photographer for any penalties and awards available under the statute. Client is responsible for
    ensuring that the Photos are removed from MLS databases at the expiration of this Agreement.
  </p>
  <p>
    Unless otherwise specifically provided elsewhere in this document or other signed agreement
    between the parties, any grant of rights is limited to a term of either one (1) year from the
    date of this Agreement, or (2) at the termination of Client’s representation of the Property, whichever
    occurs first. Further use of images beyond one (1) year requires Photographer’s permission and
    additional fees. Rights are assigned to the Client immediately upon delivery of the Photos.
  </p>
`;
//------------------------------------------------------------------------------
const relationshipOfPartiesRealEstate = () => `
  <h3>RELATIONSHIP OF PARTIES:</h3>
  <p>
    The parties agree that Photographer is an independent contractor, and that neither Photographer, nor
    Photographer’s employees or contract personnel are, or shall be deemed to be, employees
    of Client. No agency, partnership, joint venture, or employee-employer relationship is intended or created
    by this Agreement. Neither party is authorized to act as agent or bind the other party except
    as expressly stated in this Agreement. Photographer and the Photos or any other deliverables prepared by
    Photographer shall not be deemed a work for hire as defined under Copyright Law. All rights
    granted to Client are contractual in nature and are expressly defined by this Agreement.
  </p>
`;
//------------------------------------------------------------------------------
const creationRealEstate = () => `
  <h3>CREATION:</h3>
  <p>
    The manner and method of creating any Photographs is solely at the discretion of Photographer and
    the Client has no right to control Photographer’s manner and method of performance under this Agreement.
    Photographer will use his/her best efforts to: (a) ensure that the Photos conform to
    Client’s specifications; and (b) submit all Photos to Client in publishable quality, on or before
    the applicable deadlines.
  </p>
`;
//------------------------------------------------------------------------------
const imageDeliveryRealEstate = () => `
  <h3>IMAGE DELIVERY:</h3>
  <p>
    Photographer may select delivery of photographs in JPEG, TIFF, PNG, or other standard
    format, at a resolution that Photographer determines will be suitable for the Photos as licensed.
    It is the Client's responsibility to verify that the Photos are suitable for reproduction and that
    if the Photos are not deemed suitable, to notify the Photographer with five (5)business days.
    Photographer’s sole obligation will be to replace the Photos at a suitable resolution but
    in no event will Photographer be liable for poor reproduction quality, delays, or consequential damages.
  </p>
  <p>
    Unless otherwise specifically provided, Photographer is not responsible to provide images
    1) larger than 8”x10” at 300 dpi or 2) in a format higher than 8-bit or in RAW format.
    Photographer has no obligation to retain or archive any Photos delivered to Client.
  </p>
`;
//------------------------------------------------------------------------------
const reschedulingRealEstate = () => `
  <h3>RESCHEDULING:</h3>
  <p>
    If an illness or situation prevents a photo session from taking place, client may reschedule their
    session at least 48 hours prior to their shoot without penalty. Should client fail to give 48
    hours notice, or decide to completely cancel the shoot, the non-refundable deposit is forfeited and
    will not be refunded. Photographer reserves the right to reschedule due to illness, weather,
    equipment malfunction, or other circumstances beyond their control.
  </p>
`;
//------------------------------------------------------------------------------
const noExclusivityRealEstate = () => `
  <h3>NO EXCLUSIVITY:</h3>
  <p>
    This Agreement does not create an exclusive relationship between the parties. Client is free to
    engage others to perform services of the same or similar nature to those provided by Photographer, and
    Photographer shall be entitled to offer and provide design services to others, solicit other clients and
    otherwise advertise the services offered by Photographer.
  </p>
`;
//------------------------------------------------------------------------------
const indemnificationRealEstate = () => `
  <h3>INDEMNIFICATION:</h3>
  <p>
    Client will indemnify and defend Photographer against all claims, liability, damages, costs,
    and expenses, including reasonable legal fees and expenses, arising out of the creation or any
    use of the Photos or materials furnished by Client. It is the Client's responsibility to obtain the
    necessary model or property releases are ensure they are full effect and in force.
  </p>
`;
//------------------------------------------------------------------------------
const generalLawArbitrationRealEstate = ({ organization }) => `
  <h3>GENERAL LAW/ARBITRATION:</h3>
  <p>
    This Agreement sets forth the entire understanding and agreement of the parties, and supersedes any and all prior agreements between the parties. This Agreement shall be governed and interpreted and enforced in accordance with the laws of the State of ${
  organization.state
}. Any claim or litigation arising out of this Agreement or its performance may be maintained only in courts physically located in ${
  organization.city
} ${
  organization.state
}, and the parties hereby consent to the personal jurisdiction of such courts. In the event of any litigation arising out of or relating to this Agreement, the prevailing party shall be entitled to recover its attorneys’ fees incurred in the litigation. If parties are unable to resolve the dispute by negotiation, either party may start mediation and/or binding arbitration in a forum mutually agreed to by the parties.
  </p>
`;

//------------------------------------------------------------------------------
export const severabilityRealEstate = () => `
  <h3>SEVERABILITY:</h3>
  <p>
    If one or more of the provisions contained in the Agreement is found to be invalid, illegal or unenforceable in any respect, the validity, legality and enforceability of the remaining provisions shall not be affected. Such provisions shall be revised only to the extent necessary to make them enforceable.
  </p>
`;

//------------------------------------------------------------------------------
export const waiverRealEstate = () => `
  <h3>WAIVER:</h3>
  <p>
    No action of either party, other than express written waiver, may be construed to waive any provision of this Agreement and a single or partial exercise by either party of any such rights or remedies will not preclude further exercise of other rights or remedy.
  </p>
`;

const getRealEstateTermsHTML = options => {
  const firstParagraph = getFirstParagraph(options);
  const { organization } = options;

  return `
      <div>
        ${firstParagraph}
        ${scopeOfAgreementRealEstate()}
        ${rightsRealEstate()}
        ${relationshipOfPartiesRealEstate()}
        ${creationRealEstate()}
        ${imageDeliveryRealEstate()}
        ${reschedulingRealEstate()}
        ${noExclusivityRealEstate()}
        ${indemnificationRealEstate()}
        ${generalLawArbitrationRealEstate({ organization })}
        ${severabilityRealEstate()}
        ${waiverRealEstate()}
      </div>
      `;
};

export default getRealEstateTermsHTML;



// WEBPACK FOOTER //
// ./src/lib/helpers/TextEditorHelpers/getRealEstateTermsHTML.js